import React from 'react';
import { ZapIcon, ClockIcon, FileTextIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-900 text-white" data-id="element-67" data-mp="eilfb8ex51em">
      <div className="mx-auto grid w-full max-w-6xl gap-12 px-5 pb-16 pt-14 sm:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-10 lg:pb-24 lg:pt-20" data-id="element-68" data-mp="9ll8uwe5pwmz">
        <div data-id="element-69" data-mp="1297a3xzwwp6o">
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-ember-400" data-id="element-70" data-mp="129qurmgy5roe">
            <ZapIcon aria-hidden="true" className="h-4 w-4" data-id="element-71" data-mp="xbfm3f2e1n7r" />
            Guía digital · Hernia y ciática
          </p>

          <h1 className="mt-5 font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl" data-id="element-72" data-mp="s9qanyb977j5">
            Protocolo de rescate lumbar:
            <span className="mt-2 block text-ember-500" data-id="element-73" data-mp="3d2l9jc5qb50p">
              apaga el incendio de la ciática en 5 minutos
            </span>
          </h1>

          <h2 className="mt-6 max-w-xl text-lg leading-relaxed text-sand-100/85 sm:text-xl" data-id="element-74" data-mp="384s4img5wh20">
            El método de descompresión mecánica para volver a dormir y caminar sin el
            «corrientazo» eléctrico, sin fármacos y desde tu propia alfombra.
          </h2>

          <div className="mt-9 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-75" data-mp="399ti1efrlai5">
            <CtaButton data-id="element-76" data-mp="3e7uydrlt2vpx">Sí, quiero aliviar mi dolor</CtaButton>
            <p className="text-sm text-sand-100/70" data-id="element-77" data-mp="30hhovkt9n8yh">
              Pago único de <span className="font-semibold text-white" data-id="element-78" data-mp="30g6l3kztm17d">$19 USD</span> · acceso
              instantáneo
            </p>
          </div>

          <dl className="mt-12 grid max-w-lg grid-cols-3 gap-6 border-t border-white/15 pt-6" data-id="element-79" data-mp="2qkmthasahoof">
            <div data-id="element-80" data-mp="2vi53z5lygbyj">
              <dt className="sr-only" data-id="element-81" data-mp="2vjpywwc6lwwx">Duración por sesión</dt>
              <dd className="flex items-center gap-2 font-display text-2xl font-bold" data-id="element-82" data-mp="2hjf81tavgibr">
                <ClockIcon aria-hidden="true" className="h-5 w-5 text-ember-400" data-id="element-83" data-mp="2lkqyg11kl7l0" />5 min
              </dd>
              <p className="mt-1 text-xs uppercase tracking-wide text-sand-100/60" data-id="element-84" data-mp="s1rpyhl8dur4">Por sesión</p>
            </div>
            <div data-id="element-85" data-mp="nat6j94y4gjn">
              <dt className="sr-only" data-id="element-86" data-mp="na9zwokqxekx">Equipo necesario</dt>
              <dd className="font-display text-2xl font-bold" data-id="element-87" data-mp="ic87hd1fk2ws">Cero</dd>
              <p className="mt-1 text-xs uppercase tracking-wide text-sand-100/60" data-id="element-88" data-mp="ichxh0mh6a2h">Equipo</p>
            </div>
            <div data-id="element-89" data-mp="db2f5gbomhns">
              <dt className="sr-only" data-id="element-90" data-mp="1b0w05toidukd">Formato</dt>
              <dd className="flex items-center gap-2 font-display text-2xl font-bold" data-id="element-91" data-mp="1azkqxecanulv">
                <FileTextIcon aria-hidden="true" className="h-5 w-5 text-ember-400" data-id="element-92" data-mp="162ubmt8bd31i" />
                PDF
              </dd>
              <p className="mt-1 text-xs uppercase tracking-wide text-sand-100/60" data-id="element-93" data-mp="110wovp0pfq3t">En tu celular</p>
            </div>
          </dl>
        </div>

        <div className="relative" data-id="element-94" data-mp="3lsoyt0hf3v83">
          <img src="https://cdn.magicpatterns.com/uploads/fGJJkZjfzn7xWrUy5euHZH/private_openrouter-generated-image-1786998490740.png" alt="El Protocolo Ciática mostrado en laptop, tablet y celular" className="w-full rounded-2xl shadow-2xl shadow-black/40" width={1024} height={1024} data-id="element-95" data-mp="3ltqclcptivti" />
          <p className="mt-4 text-center text-sm text-sand-100/70 lg:text-left" data-id="element-96" data-mp="26a9afmitjewq">
            Libro digital + plan de posiciones, listo para leer donde estés.
          </p>
        </div>
      </div>
    </header>;
}